import { Component } from '@angular/core';
import { HeaderComponent } from "../../../../layout/header/header.component";
import { NavbarComponent } from "../../../../layout/navbar/navbar.component";
import { SidebarComponent } from "../../../../layout/sidebar/sidebar.component";
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LangChangeEvent, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AlertComponentComponent } from '../../../../components/alert/alert-component.component';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { EnrollmentModificationDto, EnrollmentModificationRequest, EnrollmentModificationResponse } from '../../../../models/enrollment/enrollmentModificationDto';
import { messageVisibility } from '../../../../models/messageVisibility.model';
import { EnrollmentService } from '../../../../services/enrollment.services';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { SharedService } from '../../../../services/shared.service';
import { EnrollmentTraductionDto } from '../../../../models/enrollment/enrollmentTraductionDto';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-modification-enrollment',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, CommonModule, ReactiveFormsModule, TranslatePipe, PaginatorComponent, AlertComponentComponent],
  templateUrl: './modification-enrollment.component.html',
  styleUrl: './modification-enrollment.component.css'
})
export class ModificationEnrollmentComponent {
  links: any[] = []; // Lista de links para el sidebar
  modificationReponse: EnrollmentModificationResponse = new EnrollmentModificationResponse();
  modificationRequest: EnrollmentModificationRequest = new EnrollmentModificationRequest();
  modificationSelected!: EnrollmentModificationDto | null;
  modificationReponseTraductions: EnrollmentTraductionDto[] = [];
  selectedRowId: number | null = null;
  modificationForm!: FormGroup;
  isCreate: boolean = false;
  errorMessage: string = '';
  messageVisibility: messageVisibility = new messageVisibility()
  private langChangeSubscription!: Subscription;

  constructor(private routelinks: RoutelinksService, private translateService: TranslateService, private enrollmentService: EnrollmentService, private formBuilder: FormBuilder, private sharedService: SharedService

  ) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksEnrollment; // Inicializa la propiedad en ngOnInit
    this.initFormReactiveEnrollment();
    this.getAllEnrollment();
    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      this.modificationRequest.pageRequest.page = page;
      this.getAllEnrollment();
    });
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.getAllEnrollment();
    });
  }

  private initFormReactiveEnrollment(): void {
    this.modificationForm = this.formBuilder.group({
      idEnrollmentBehaviorPatternModification: [],
      codeModification: [''],
      shortDescription: ['', [Validators.required]],
      typology: [''],
      active: new FormControl("S"),
      academicFeesCharge: new FormControl(true),
      learningResourcesFee: new FormControl(true),
      adminFeeCharge: new FormControl(true),
      descriptionCas: ['', [Validators.required]],
      descriptionCat: ['', [Validators.required]],
      descriptionEng: ['', [Validators.required]],
    });
  }

  getAllEnrollment() {
    this.enrollmentService.getListEnrollmentModification(this.modificationRequest.pageRequest).subscribe({
      next: response => {
        console.log(response)
        if (response != null) {
          this.modificationReponseTraductions = response.listPatternModification.enrollmentBehaviorPatternModificationTraductionDto
          this.modificationReponse.EnrollmentModificationDto = response.listPatternModification
          this.modificationReponse.pageDto = response.pageDto !== undefined ? response.pageDto : null;
        }
      }
    });
  }

  checkRow(modification?: EnrollmentModificationDto) {
    this.modificationForm.reset()
    if (modification) {
      if (this.selectedRowId === modification.idEnrollmentBehaviorPatternModification) {
        this.selectedRowId = null;
        return;
      }
      console.log(modification)
      this.modificationSelected = modification
      this.selectedRowId = modification.idEnrollmentBehaviorPatternModification || null
      this.modificationForm.get('codeModification')?.patchValue(modification?.codeModification)
      this.modificationForm.get('shortDescription')?.patchValue(modification?.shortDescription)
      this.modificationForm.get('typology')?.patchValue(modification?.typology)
      this.modificationForm.get('active')?.patchValue(modification?.active)

      modification.academicFeesCharge == 'S' ? this.modificationForm.get('academicFeesCharge')?.patchValue(true) : this.modificationForm.get('academicFeesCharge')?.patchValue(false)
      modification.learningResourcesFee == 'S' ? this.modificationForm.get('learningResourcesFee')?.patchValue(true) : this.modificationForm.get('learningResourcesFee')?.patchValue(false)
      modification.adminFeeCharge == 'S' ? this.modificationForm.get('adminFeeCharge')?.patchValue(true) : this.modificationForm.get('adminFeeCharge')?.patchValue(false)
      modification.enrollmentBehaviorPatternModificationTraductionDto?.forEach(modifyTraduction => {
        modifyTraduction.languageDto?.idLanguage == 1 ? this.modificationForm.get('descriptionCas')?.patchValue(modifyTraduction.longDescription) : null;
        modifyTraduction.languageDto?.idLanguage == 2 ? this.modificationForm.get('descriptionCat')?.patchValue(modifyTraduction.longDescription) : null;
        modifyTraduction.languageDto?.idLanguage == 3 ? this.modificationForm.get('descriptionEng')?.patchValue(modifyTraduction.longDescription) : null;
      });

    } else {
      // Modo creación
      this.modificationSelected = null
      this.selectedRowId = null;
      this.isCreate = true;
      this.modificationForm.enable();
      this.modificationForm.reset();
    }
  }

  createOrUpdateModification(): void {
    console.log(this.modificationForm.value)
    if (this.modificationForm.valid) {

      this.buildModificationDto()
      if (!this.selectedRowId) {
        this.enrollmentService.insertEnrollmentModification(this.modificationRequest.EnrollmentModificationDto).subscribe({
          next: () => {
            this.messageVisibility.isErrorFirts = false;
            this.messageVisibility.isSuccessFirst = true;
            this.errorMessage = "S'ha creat correctament"
            this.resetValues();
          }, error: (error: { error: { message: string; }; }) => {
            this.messageVisibility.isErrorFirts = true;
            this.messageVisibility.isSuccessFirst = false;
            this.errorMessage = error.error.message
          }
        })
      }
      //modo edicion
      else {
        this.enrollmentService.updateEnrollmentModification(this.modificationRequest.EnrollmentModificationDto).subscribe({
          next: () => {
            this.messageVisibility.isErrorFirts = false;
            this.messageVisibility.isSuccessFirst = true;
            this.errorMessage = "S'ha editat correctament"
            this.resetValues();
          }, error: (error) => {
            this.messageVisibility.isErrorFirts = true;
            this.messageVisibility.isSuccessFirst = false;
            this.errorMessage = error.error.message
          }
        })
      }
    } else {
      this.messageVisibility.isErrorFirts = true;
      this.messageVisibility.isSuccessFirst = false;
      this.errorMessage = 'obligatorios'
    }

  }

  buildModificationDto() {
    this.modificationRequest.EnrollmentModificationDto = new EnrollmentModificationDto(); // Inicializa de 0 el objeto
    if (this.selectedRowId) {
      this.modificationRequest.EnrollmentModificationDto.idEnrollmentBehaviorPatternModification = this.selectedRowId
    }
    this.modificationRequest.EnrollmentModificationDto.codeModification = this.modificationForm.get('codeModification')?.value;
    this.modificationRequest.EnrollmentModificationDto.shortDescription = this.modificationForm.get('shortDescription')?.value;
    this.modificationRequest.EnrollmentModificationDto.typology = this.modificationForm.get('typology')?.value;
    this.modificationRequest.EnrollmentModificationDto.active = this.modificationForm.get('active')?.value;

    this.modificationForm.get('academicFeesCharge')?.value ? this.modificationRequest.EnrollmentModificationDto.academicFeesCharge = 'S' : this.modificationRequest.EnrollmentModificationDto.academicFeesCharge = 'N'
    this.modificationForm.get('learningResourcesFee')?.value ? this.modificationRequest.EnrollmentModificationDto.learningResourcesFee = 'S' : this.modificationRequest.EnrollmentModificationDto.learningResourcesFee = 'N'
    this.modificationForm.get('adminFeeCharge')?.value ? this.modificationRequest.EnrollmentModificationDto.adminFeeCharge = 'S' : this.modificationRequest.EnrollmentModificationDto.adminFeeCharge = 'N'
    this.modificationRequest.EnrollmentModificationDto.enrollmentBehaviorPatternModificationTraductionDto = [
      { languageDto: { idLanguage: 1, code: "es" }, longDescription: undefined, idEnrollmentBehaviorPatternModificationTraduction: null },
      { languageDto: { idLanguage: 2, code: "ca" }, longDescription: undefined, idEnrollmentBehaviorPatternModificationTraduction: null },
      { languageDto: { idLanguage: 3, code: "en" }, longDescription: undefined, idEnrollmentBehaviorPatternModificationTraduction: null }
    ];
    this.modificationRequest.EnrollmentModificationDto.enrollmentBehaviorPatternModificationTraductionDto.forEach((translation) => {
      if (translation.languageDto?.code === "es" || translation.languageDto?.idLanguage === 1) {
        translation.longDescription = this.modificationForm.get('descriptionCas')?.value ?? undefined;
        console.log(this.modificationSelected)
        if (this.modificationSelected?.enrollmentBehaviorPatternModificationTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 1 }) && this.modificationSelected?.enrollmentBehaviorPatternModificationTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 1 }).length > 0) {
          translation.idEnrollmentBehaviorPatternModificationTraduction = this.modificationSelected?.enrollmentBehaviorPatternModificationTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 1 })[0].idEnrollmentBehaviorPatternModificationTraduction || undefined
        } else {
          translation.idEnrollmentBehaviorPatternModificationTraduction = null
        }      } else if (translation.languageDto?.code === "ca" || translation.languageDto?.idLanguage === 2) {
        translation.longDescription = this.modificationForm.get('descriptionCat')?.value ?? undefined;
        if (this.modificationSelected?.enrollmentBehaviorPatternModificationTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 2 }) && this.modificationSelected?.enrollmentBehaviorPatternModificationTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 2 }).length > 0) {
          translation.idEnrollmentBehaviorPatternModificationTraduction = this.modificationSelected?.enrollmentBehaviorPatternModificationTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 2 })[0].idEnrollmentBehaviorPatternModificationTraduction || undefined
        } else {
          translation.idEnrollmentBehaviorPatternModificationTraduction = null
        }
      } else if (translation.languageDto?.code === "en" || translation.languageDto?.idLanguage === 3) {
        translation.longDescription = this.modificationForm.get('descriptionEng')?.value ?? undefined;
           if (this.modificationSelected?.enrollmentBehaviorPatternModificationTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 3 }) && this.modificationSelected?.enrollmentBehaviorPatternModificationTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 3 }).length > 0) {
          translation.idEnrollmentBehaviorPatternModificationTraduction = this.modificationSelected?.enrollmentBehaviorPatternModificationTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 3 })[0].idEnrollmentBehaviorPatternModificationTraduction || undefined
        } else {
          translation.idEnrollmentBehaviorPatternModificationTraduction = null
        }
      }
    });
  }

  private resetValues(): void {
    this.getAllEnrollment();
    this.modificationForm.reset();
    this.selectedRowId = null;
  }

}
